var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 48,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-90 0 48)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 32.5C30.3807 32.5 31.5 31.3807 31.5 30C31.5 28.6193 30.3807 27.5 29 27.5C27.6193 27.5 26.5 28.6193 26.5 30C26.5 31.3807 27.6193 32.5 29 32.5Z",
    fill: "#471070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 32.5C20.3807 32.5 21.5 31.3807 21.5 30C21.5 28.6193 20.3807 27.5 19 27.5C17.6193 27.5 16.5 28.6193 16.5 30C16.5 31.3807 17.6193 32.5 19 32.5Z",
    fill: "#471070"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_44353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 26C29.2885 26.0001 30.5272 26.4975 31.4578 27.3887C32.3884 28.2798 32.9391 29.4958 32.995 30.783L33 31V32C33.0002 32.5046 32.8096 32.9906 32.4665 33.3605C32.1234 33.7305 31.6532 33.9572 31.15 33.995L31 34H17C16.4954 34.0002 16.0094 33.8096 15.6395 33.4665C15.2695 33.1234 15.0428 32.6532 15.005 32.15L15 32V31C15.0001 29.7115 15.4975 28.4728 16.3887 27.5422C17.2798 26.6116 18.4958 26.0609 19.783 26.005L20 26H28ZM24 14C25.3261 14 26.5979 14.5268 27.5355 15.4645C28.4732 16.4021 29 17.6739 29 19C29 20.3261 28.4732 21.5979 27.5355 22.5355C26.5979 23.4732 25.3261 24 24 24C22.6739 24 21.4021 23.4732 20.4645 22.5355C19.5268 21.5979 19 20.3261 19 19C19 17.6739 19.5268 16.4021 20.4645 15.4645C21.4021 14.5268 22.6739 14 24 14Z",
    fill: "#471070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_44353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabor);
export default __webpack_public_path__ + "static/media/Labor.c8d83187cacfee341672bc8765e3d2b7.svg";
export { ForwardRef as ReactComponent };